export default __webpack_public_path__ + "507b4c5c27de365c616ba368e63a946b.svg";